import type {TFunction} from "i18next";

/** Maps authenticated route `key` → `nav.*` catalog slug (v2 vendored JSON). */
const ROUTE_NAV_KEYS: Record<string, string> = {
  dashboard: "dashboard",
  home: "home",
  dispatchdesk: "dispatch_desk",
  dars: "dar",
  incidents: "incidents",
  propertyinspectionreport: "property_inspection",
  poolaccesslogs: "pool_access",
  tennisaccesslogs: "tennis_access",
  gymaccesslogs: "gym_access",
  recreationaccesslogs: "recreation_access",
  vehicles: "parking_enforcement",
  dispatchlogs: "dispatch",
  "panic-alerts": "alerts",
  "shifts-history": "shift_history",
  briefings: "briefing",
  reportrequests: "reports",
  households: "households",
  pools: "pools",
  safelistings: "safelisting",
  storedvehicles: "stored_vehicles",
  citations: "citations",
  users: "users",
  properties: "properties",
  shifts: "shifts",
  tasks: "tasks",
  tennis: "tennis_courts",
  gym: "gyms",
  recreation: "recreation_areas",
  permanentparking: "permanent_parking",
  "rbac-admin": "rbac",
  company: "company",
  "officer-on-guard": "supervisor_on_call",
  "panic-button-settings": "panic_button_settings",
  "company-vehicles": "company_vehicles",
  dispatchcenters: "dispatch_centers",
  patrolroutes: "patrol_routes",
  "emergency-contacts": "emergency_contacts",
  support: "support",
  "view-as-user": "view_as_user",
  offline: "offline",
};

export function tNavRouteLabel(
  routeKey: string | undefined,
  fallbackLabel: string,
  t: TFunction,
): string {
  if (!routeKey) return fallbackLabel;

  const navKey = ROUTE_NAV_KEYS[routeKey];
  if (!navKey) return fallbackLabel;
  return t(navKey, {defaultValue: fallbackLabel});
}

export function tNavAdminPanelSectionLabel(fallbackLabel: string, t: TFunction): string {
  return t("admin_panel", {defaultValue: fallbackLabel});
}

export function tOpenInGoogleMapsLabel(t: TFunction<"common">): string {
  return t("open_in_google_maps", {defaultValue: "Open in Google Maps"});
}
